import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { QuotesContextProvider } from './QuotesContext';
import { ContractsContextProvider } from '../contracts/ContractsContext';
import ListQuotes from './ListQuotes';
import CreateUpdateQuote from './CreateUpdateQuote';
import ProductsQuote from './ProductsQuote';
import { subRoutes } from '../../utils/constants/routes';
import ListTickets from '../tickets/ListTickets';
import ShowContract from '../contracts/ShowContract';

const QuotesRouter = () => {
  return (
    <QuotesContextProvider>
      <Routes>
        <Route
          path=":subPath/create"
          element={<CreateUpdateQuote purpose="create" />}
        />
        <Route
          path=":subPath/edit/:id"
          element={<CreateUpdateQuote purpose="edit" />}
        />
        <Route
          path={`${subRoutes.QUOTES.QUOTES_IN_EXEMPTION}/show/:id`}
          element={
            <ContractsContextProvider>
              <ShowContract />
            </ContractsContextProvider>
          }
        />
        <Route
          path={`${subRoutes.QUOTES.QUOTES_SAVED}/show/:id`}
          element={
            <ContractsContextProvider>
              <ShowContract />
            </ContractsContextProvider>
          }
        />
        <Route
          path=":subPath/edit_amendment/:id"
          element={<CreateUpdateQuote purpose="edit_amendment" />}
        />
        <Route
          path=":subPath/amendment/:id"
          element={<CreateUpdateQuote purpose="amendment" />}
        />
        <Route
          path={subRoutes.QUOTES.QUOTES_IN_EXEMPTION}
          element={<ListTickets contractsStatus="QUOTE" />}
        />
        <Route path={subRoutes.QUOTES.QUOTES_SAVED} element={<ListQuotes />} />

        <Route path="productsquote/:filter" element={<ProductsQuote />} />

        <Route index element={<ListQuotes />} />
      </Routes>
    </QuotesContextProvider>
  );
};

export const amendmentPurposes = [
  'edit_amendment',
  'amendment',
  'duplicate_amendment'
];

export const editPurposes = [
  'edit',
  'edit_amendment',
  'amendment',
  'duplicate_amendment',
  'duplicate'
];

export default QuotesRouter;
